import {
	PURCHASE_ORDER_LIST,
	PURCHASE_ORDER_LIST_SUCCESS,
	TOGGLE_ITEM_MENU,
	SET_PARAMS,
	FILTER_INPUT_CHANGEVALUE,
	FILTER_SELECT_CHANGEVALUE,
	PURCHASE_ORDER_ROW_DATA,
	PURCHASE_ORDER_ROW_DATA_SUCCESS,
	LIST_LAYOUT,
	FILTERS_SHOW_RIGHT_SIDEBAR,
	FILTERS_HIDE_RIGHT_SIDEBAR,
	CLEAR_FILTER,
	PDF_DOWNNLOAD,
	MR_CODE_DETAILS,
	MR_CODE_DETAILS_SUCCESS,
	PI_CODE_DETAILS,
	PI_CODE_DETAILS_SUCCESS,
	PO_ITEM_ACKNOWLEDGE_OPEN,
	PO_ITEM_ACKNOWLEDGE_CLOSE,
	PO_ITEM_INPUT_CHANGEVALUE,
	PO_ITEM_ACKNOWLEDGE,
	PURCHASE_ORDER_CLOSE,
	PURCHASE_ORDER_FOUCS_POST,
	PO_CLOSE_MODAL_OPEN,
	PO_CLOSE_MODAL_CLOSE,
	PO_CLOSE_DESCRIPTION,
	TOGGLE_EDIT,
	ORDER_DISC_PERCENT_CHANGEVALUE,
	HANDLE_BASE_PRICE,
	ITEM_GROSS_VAL_CHANGEVALUE,
	ORDER_BASEPRICE_CHANGEVALUE,
	ORDER_TAXTYPE_CHANGEVALUE,
	ORDER_TAX_CHANGEVALUE,
	SUBMIT_EDIT_ORDER,
	SUBMIT_EDIT_ORDER_SUCCESSFULL,
	VIEW_LOG_SHOW_RIGHT_SIDEBAR_PURCHASE,
	VIEW_LOG_HIDE_RIGHT_SIDEBAR_PURCHASE,
	TOGGLE_EDIT_WITH_VALUE,
	PO_HISTORY_SUCCESS,
	PO_AUTHORIZATION,
	PO_AUTHORIZATION_SUCCESS,
	APPROVE_EDIT_WITH_VALUE,
} from "./actionTypes";

const initialState = {
	loading: false,
	POList: [],
	toggledRows: {},
	POListCount: 0,
	isToggled: false,
	PORowData: {},
	POItemHistory: [],
	PoAuthorization: {},
	Sortvar: {
		code: "ORDER NO",
		createdon: "CREATED ON",
	},
	params: {
		no_of_pages: 0,
		page_size: 10,
		page: 1,
		search: "",
		currentSort: "code",
		sortOrder: "-",
	},
	layout: "list",
	POIacknowledgeData: {},
	POIacknowledge_Model: false,
	showFilterRightSidebar: false,
	POClose_Model: false,
	POClose_Model_Description: {},
	ToggleEditBtn: false,
	showViewLogRightSidebar: false,
	itemTimeLine: [],
	mrIssueItem: [],
	PIitemTimeLine: [],
	RFQItemsTimeLine: [],
	POItemsTimeLine: [],
	IGPItemsTimeLine: [],
	IGPTimeLine: [],
	selectedPIItemId: 0,
	selectedCQItemId: 0,
	selectedIGPItemId: 0,
};

const PurchaseOrder = (state = initialState, action) => {
	switch (action.type) {
		case PURCHASE_ORDER_LIST:
			state = {
				...state,
				loading: true,
			};
			break;
		case PURCHASE_ORDER_LIST_SUCCESS:
			var noofpages = Math.ceil(
				action.payload.count / state.params.page_size
			);
			state = {
				...state,
				POListCount: action.payload.count,
				POList: action.payload.results,
				params: {
					...state.params,
					no_of_pages: noofpages,
				},
				loading: false,
			};
			break;
		case TOGGLE_ITEM_MENU:
			var POList = state.POList?.map((i) => {
				if (i.id === action.payload) {
					i.actionMenu = !i.actionMenu;
				} else {
					i.actionMenu = false;
				}
				return i;
			});

			state = {
				...state,
				POList: POList,
			};
			break;
		case SET_PARAMS:
			state = {
				...state,
				params: action.payload,
			};
			break;
		case FILTER_INPUT_CHANGEVALUE:
			state = {
				...state,
				params: {
					...state.params,
					[action.payload.key]: action.payload.value,
				},
			};
			break;
		case FILTER_SELECT_CHANGEVALUE:
			state = {
				...state,
				filterdata: {
					...state.filterdata,
					[action.payload.key]: action.payload.label,
				},
				params: {
					...state.params,
					[action.payload.key2]: action.payload.value,
				},
			};
			break;
		case TOGGLE_EDIT:
			state = {
				...state,
				// ToggleEditBtn: !state.ToggleEditBtn,
				PORowData: {
					...state.PORowData,
					poitems: state.PORowData?.poitems?.map((item) => {
						if (item.showEditBtn != undefined) {
							if (item.id == action.payload) {
								item.showEditBtn = !item.showEditBtn;
							}
						} else {
							item.showEditBtn = false;
						}
						return item;
					}),
				},
			};
			break;
		case TOGGLE_EDIT_WITH_VALUE:
			state = {
				...state,
				ToggleEditBtn: action.payload,
			};
			break;
		case APPROVE_EDIT_WITH_VALUE:
			state = {
				...state,
				toggledRows: action.payload,
			};
			break;
		case PURCHASE_ORDER_ROW_DATA:
			state = {
				...state,
				loading: true,
				PORowData: {},
			};
			break;
		case PURCHASE_ORDER_ROW_DATA_SUCCESS:
			state = {
				...state,
				PORowData: {
					...action.payload,
					poitems: action.payload?.poitems?.map((item) => {
						item.showEditBtn = false;
						return item;
					}),
				},
				loading: false,
			};
			break;
		case MR_CODE_DETAILS:
			state = {
				...state,
				loading: true,
				poItemId: action.payload.ItemId,
			};
			break;
		case MR_CODE_DETAILS_SUCCESS:
			var poitems = state.PORowData.poitems.map((item, i) => {
				if (item.id === state.poItemId) {
					item.mrdata = action.payload;
				}
				return item;
			});
			state = {
				...state,
				PORowData: { ...state.PORowData, poitems: poitems },
				loading: false,
			};
			break;
		case PI_CODE_DETAILS:
			state = {
				...state,
				loading: true,
				poItemId: action.payload.ItemId,
			};
			break;
		case PI_CODE_DETAILS_SUCCESS:
			var poitems_1 = state.PORowData.poitems.map((item, i) => {
				if (item.id === state.poItemId) {
					item.pidata = action.payload;
				}
				return item;
			});
			state = {
				...state,
				PORowData: { ...state.PORowData, poitems: poitems_1 },
				loading: false,
			};
			break;

		case HANDLE_BASE_PRICE:
			state = {
				...state,
				PORowData: {
					...state.PORowData,
					// poitems: state.PORowData.poitems.map((item) =>{

					// })
				},
			};
			break;
		case ORDER_BASEPRICE_CHANGEVALUE:
			var qitems8 = state.PORowData.poitems.map((i) => {
				if (i.id === action.payload.item.id) {
					i.baseprice = action.payload.value;
					i.price = action.payload.price;
					i.discount = action.payload.discount;
					// i.discountpercent = action.payload.discountpercent;
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems7,
				PORowData: {
					...state.PORowData,
					poitems: qitems8,
				},
			};
			break;
		case ORDER_TAX_CHANGEVALUE:
			var qitems5 = state.PORowData.poitems.map((i) => {
				if (i.id === action.payload.item.id) {
					i.tax = {
						id: action.payload.id,
						tax: action.payload.tax,
						name: action.payload.name,
					};
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems7,
				PORowData: {
					...state.PORowData,
					poitems: qitems5,
				},
			};
			break;
		case ORDER_TAXTYPE_CHANGEVALUE:
			var qitems4 = state.PORowData.poitems.map((i) => {
				if (i.id === action.payload.item.id) {
					i.taxtype = action.payload.value;
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems7,
				PORowData: {
					...state.PORowData,
					poitems: qitems4,
				},
			};
			break;
		case ITEM_GROSS_VAL_CHANGEVALUE:
			var qitems6 = state.PORowData.poitems.map((i) => {
				if (i.id === action.payload.item.id) {
					i.gross = parseFloat(action.payload.net);
					i.taxamount = parseFloat(action.payload.taxamount);
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems6,
			};
			break;

		case ORDER_DISC_PERCENT_CHANGEVALUE:
			var qitems7 = state.PORowData.poitems.map((i) => {
				if (i.id === action.payload.item.id) {
					i.discountpercent = action.payload.value;
					i.price = action.payload.price;
					i.discount = action.payload.discount;
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems7,
				PORowData: {
					...state.PORowData,
					poitems: qitems7,
				},
			};
			break;
		case PO_ITEM_ACKNOWLEDGE_OPEN:
			state = {
				...state,
				loading: false,
				POIacknowledgeData: {
					poitem_id: action.payload.POItem_Id,
					purchaseorder_id: action.payload.PO_ID,
				},
				POIacknowledge_Model: true,
			};
			break;
		case PO_ITEM_ACKNOWLEDGE_CLOSE:
			state = {
				...state,
				loading: false,
				POIacknowledge_Model: false,
				POIacknowledgeData: {},
			};
			break;

		case PO_CLOSE_MODAL_OPEN:
			state = {
				...state,
				POClose_Model: true,
			};
			break;
		case PO_CLOSE_MODAL_CLOSE:
			state = {
				...state,
				POClose_Model: false,
			};
			break;
		case PO_ITEM_INPUT_CHANGEVALUE:
			state = {
				...state,
				POIacknowledgeData: {
					...state.POIacknowledgeData,
					[action.payload.key]: action.payload.value,
				},
			};
			break;

		case PO_CLOSE_DESCRIPTION:
			state = {
				...state,
				POClose_Model_Description: {
					[action.payload.key]: action.payload.value,
				},
			};
			break;
		case PO_ITEM_ACKNOWLEDGE:
			state = {
				...state,
				loading: true,
			};
			break;

		case SUBMIT_EDIT_ORDER:
			state = {
				...state,
				loading: true,
			};
			break;
		case SUBMIT_EDIT_ORDER_SUCCESSFULL:
			state = {
				...state,
				loading: false,
			};
			break;
		case LIST_LAYOUT:
			state = {
				...state,
				layout: action.payload,
				loading: false,
			};
			break;
		case FILTERS_SHOW_RIGHT_SIDEBAR:
			state = {
				...state,
				showFilterRightSidebar: !state.showFilterRightSidebar,
			};
			break;
		case VIEW_LOG_SHOW_RIGHT_SIDEBAR_PURCHASE:
			state = {
				...state,
				showViewLogRightSidebar: !state.showViewLogRightSidebar,
			};
			break;
		case PO_HISTORY_SUCCESS:
			state = {
				...state,
				POItemHistory: action.payload,
			};
			break;
		case PO_AUTHORIZATION:
			state = {
				...state,

				PoAuthorization: action.payload,
				loading: true,
			};
			break;
		case PO_AUTHORIZATION_SUCCESS:
			state = {
				...state,

				PoAuthorization: action.payload,
				loading: false,
			};
			break;

		case VIEW_LOG_HIDE_RIGHT_SIDEBAR_PURCHASE:
			state = {
				...state,
				itemTimeLine: [],
				mrIssueItem: [],
				PIitemTimeLine: [],
				RFQItemsTimeLine: [],
				POItemsTimeLine: [],
				IGPItemsTimeLine: [],
				IGPTimeLine: [],
				selectedPIItemId: 0,
				selectedCQItemId: 0,
				selectedIGPItemId: 0,
				showViewLogRightSidebar: false,
			};
			break;
		case FILTERS_HIDE_RIGHT_SIDEBAR:
			state = {
				...state,

				showFilterRightSidebar: false,
			};
			break;
		case CLEAR_FILTER:
			state = {
				...state,
				filterdata: {},
			};
			break;
		case PDF_DOWNNLOAD:
			state = {
				...state,
				loading: false,
			};
			break;
		case PURCHASE_ORDER_CLOSE:
			state = {
				...state,
				loading: false,
			};
			break;
		case PURCHASE_ORDER_FOUCS_POST:
			state = {
				...state,
				loading: false,
			};
			break;
		default:
			state = { ...state };
			break;
	}

	return state;
};
export default PurchaseOrder;
